export default __webpack_public_path__ + "static/media/nikhil.69273cff.jpg";